(function () {
  function init(form) {
    if (!form || form.dataset.naokoClubInit === '1') return;
    form.dataset.naokoClubInit = '1';

    var consent = form.querySelector('[data-naoko-consent]');
    var submit = form.querySelector('[data-naoko-submit]');
    var sending = false;
    var resuming = false;

    if (consent && submit) {
      var sync = function () {
        submit.disabled = !consent.checked;
      };

      consent.addEventListener('change', sync);
      sync();
    }

    form.addEventListener('submit', function (event) {
      if (resuming || event.defaultPrevented) return;

      if (sending) {
        event.preventDefault();
        return;
      }

      var emailInput = form.querySelector('[name="contact[email]"]');

      if (!emailInput || !form.checkValidity()) return;
      if (consent && !consent.checked) return;

      var email = emailInput.value.trim();
      if (!email) return;

      // Jeśli SDK jest niedostępne, formularz działa normalnie.
      if (
        !window.SR ||
        !window.SR.event ||
        typeof window.SR.event.sendFormData !== 'function' ||
        typeof form.requestSubmit !== 'function'
      ) {
        return;
      }

      event.preventDefault();
      sending = true;

      var submitter = event.submitter;
      var resumed = false;
      var timer;

      function resume() {
        if (resumed) return;
        resumed = true;
        window.clearTimeout(timer);
        sending = false;

        // Ponowna wysyłka zachowuje walidację formularza.
        resuming = true;
        try {
          if (submitter && submitter.form === form) {
            form.requestSubmit(submitter);
          } else {
            form.requestSubmit();
          }
        } finally {
          resuming = false;
        }
      }

      // Awaria Synerise nie może blokować zapisu do klubu.
      timer = window.setTimeout(resume, 1500);

      try {
        var result = window.SR.event.sendFormData('naoko-club', {
          email: email
        });

        if (result && typeof result.then === 'function') {
          result.then(resume, resume);
        }
      } catch (error) {
        resume();
      }
    });
  }

  function boot() {
    document.querySelectorAll('.naoko-club-form').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
